import { render, staticRenderFns } from "./SelectColour.vue?vue&type=template&id=f8be2da8&scoped=true&"
import script from "./SelectColour.vue?vue&type=script&lang=js&"
export * from "./SelectColour.vue?vue&type=script&lang=js&"
import style0 from "./SelectColour.vue?vue&type=style&index=0&id=f8be2da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8be2da8",
  null
  
)

export default component.exports